// extracted by mini-css-extract-plugin
export default {"section":"styles_section__s802S","header":"styles_header__7X179","subtitle":"styles_subtitle__2bax2"};